import { useAuthStore } from '../stores/auth'

// hasPerm mirrors the backend check (permissions.Has): exact permission or "*".
// The list comes from /auth/me and login. While it is unknown (no session yet,
// or a session restored without the field) the answer is true — the server
// stays the authority, the UI only hides what is known to be denied.
export function hasPerm(permissions: string[] | undefined, perm: string): boolean {
  if (!permissions) return true
  return permissions.includes('*') || permissions.includes(perm)
}

export function useCan(perm: string): boolean {
  return hasPerm(useAuthStore((s) => s.user?.permissions), perm)
}

// useCanFn returns a checker for several permissions at once (nav filtering).
export function useCanFn(): (perm: string) => boolean {
  const permissions = useAuthStore((s) => s.user?.permissions)
  return (perm) => hasPerm(permissions, perm)
}
